import styled from 'styled-components';
import { ConfirmationModalVariant } from './ConfirmationModal.type';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const ModalContainer = styled.div`
  background: white;
  border-radius: 8px;
  width: 90vw;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
`;

export const ModalHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  color: #333;
`;

export const ModalBody = styled.div`
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const ModalMessage = styled.p`
  margin: 0;
  font-size: 1rem;
  color: #666;
  line-height: 1.5;
`;

export const ModalFooter = styled.div`
  padding: 20px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

interface ButtonProps {
  variant?: 'primary' | 'secondary' | 'danger';
}

export const Button = styled.button<ButtonProps>`
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;

  ${(props) => {
    switch (props.variant) {
      case 'danger':
        return `
          background-color: #f44336;
          color: white;

          &:hover:not(:disabled) {
            background-color: #d32f2f;
          }

          &:focus {
            outline: none;
            box-shadow: 0 0 0 2px rgba(244, 67, 54, 0.2);
          }

          &:disabled {
            background-color: #ccc;
            cursor: not-allowed;
          }
        `;
      case 'primary':
        return `
          background-color: #2196f3;
          color: white;

          &:hover:not(:disabled) {
            background-color: #1976d2;
          }

          &:focus {
            outline: none;
            box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);
          }

          &:disabled {
            background-color: #ccc;
            cursor: not-allowed;
          }
        `;
      case 'secondary':
      default:
        return `
          background-color: #f5f5f5;
          color: #333;

          &:hover {
            background-color: #e0e0e0;
          }

          &:focus {
            outline: none;
            box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
          }
        `;
    }
  }}
`;
